<template>
  <div class="header">
    <div class="overlay">
      <img class="logo" src="../assets/logo.png"/>
      <h1 class="header-title">Bernlef</h1>
      <Register/>

      <div class="buttons d-flex flex-row justify-center justify-sm-end justify-md-end justify-lg-end justify-xl-end">
        <v-btn icon color="white" href="https://bernlef.frl/" target="_blank">
          <v-icon>mdi-earth</v-icon>
        </v-btn>
        <v-btn icon color="white" href="https://www.facebook.com/FFJBernlef" target="_blank">
          <v-icon>mdi-facebook</v-icon>
        </v-btn>
        <v-btn icon color="white" href="https://www.instagram.com/f.f.j.bernlef/" target="_blank">
          <v-icon>mdi-instagram</v-icon>
        </v-btn>
        <v-btn icon color="white" href="https://www.youtube.com/channel/UCUPMvNr7EWY1LYI5U9-MM0A" target="_blank">
          <v-icon>mdi-youtube</v-icon>
        </v-btn>
      </div>

    </div>
  </div>
</template>

<script>
  import Register from "@/components/Register";

  export default {
    data: () => ({
    }),

    components: {
        Register
    },
  }
</script>

<style scoped lang="scss">
  .header {
    background-image: url("../assets/background.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: scroll;
    text-align: center;
    width: 100%;
    height: 500px;

    @media (min-width: 540px) {
      background-attachment: fixed;
    }

    .overlay {
      height: 100%;
      width: 100%;
      background: rgba(0,0,0,0.3);
      overflow: hidden;
      position: relative;

      .header-title {
        color: white;
        font-size: 5em;
      }

      .buttons {
        position: absolute;
        bottom: 10px;
        left: 0;
        right: 0;


        .v-btn {
          height: 70px !important;
          width: 70px !important;

          .v-icon {
            font-size: 50px !important;
          }
        }
      }
    }

    .logo {
      margin-top: 10px;
      width: 300px;
    }
  }
</style>
